import React from "react";
import classNames from "classnames/bind";
import { useIntl } from "react-intl";
import styles from "./LayoutStyles.module.scss";
import { Col } from "./Row";

const cx = classNames.bind(styles);

const InputGroup = (props) => {
  const { children, label, errors, required, labelInfo, className } = props;

  const generateChildren = () => {
    if (Array.isArray(children)) {
      return children.map((child, idx) =>
        React.cloneElement(child, { key: idx, ...child.props })
      );
    } else {
      return React.cloneElement(children, children.props);
    }
  };
  return (
    <div className={cx("inputGroup", { [className]: className })}>
      {label && (
        <label className={cx("inputLabel")} htmlFor="">
          {label} {required && " *"}
          {labelInfo && <small className={cx("labelInfo")}>{labelInfo}</small>}
        </label>
      )}
      {children && generateChildren()}
      {errors && <span className={cx("inputError")}> {errors} </span>}
    </div>
  );
};

const Input = React.forwardRef((props: any, ref: any) => {
  const { formatMessage: f } = useIntl();
  const {
    type,
    options,
    value,
    checkedValue,
    checked,
    useLabel,
    md,
    errors,
    padding = 0,
    className,
    ...radioProps
  } = props;

  if (type === "radio") {
    return options.map((opt, key) => (
      <Col md={md ?? 2} key={key} padding={padding}>
        <label className={cx("RadioBoxLabel", { [className]: className })}>
          <input
            type="radio"
            value={opt.value}
            ref={ref}
            checked={checkedValue === opt.value}
            {...radioProps}
          />
          <span className={cx("RadioBoxSymbol")} />
          {useLabel ? opt.label : f({ id: opt.label })}
        </label>
      </Col>
    ));
  }
  return (
    <>
      <input className={cx("inputItem")} ref={ref} {...props} />
      {errors && (
        <span className={cx("inputError")}>{f({ id: "Errors.Required" })}</span>
      )}
    </>
  );
});

const CheckBox = React.forwardRef((props: any, ref: any) => {
  const { formatMessage: f } = useIntl();
  const { errors, label, name, ...restProps } = props;

  return (
    <div className={cx("checkBoxWrapper")}>
      <div className={cx("checkBoxItem")}>
        <input type="checkbox" name={name} id={name} ref={ref} {...restProps} />
        <label htmlFor={name}>
          <span className={cx("checkBoxSymbol")} />
          {label}
        </label>
      </div>
      {errors && (
        <span className={cx("inputError")}>{f({ id: "Errors.Required" })}</span>
      )}
    </div>
  );
});

export { InputGroup, Input, CheckBox };
